import { InputAdornment, TextField } from "@material-ui/core";
import { memo, useEffect } from "react";
import { useState } from "react";
import MaskService from "../../../../utils/mask/maskService";

const DoubleInputs = ({
  percentValue,
  monetaryValue,
  setNewArray = () => {},
  array = [],
  row = [],
  percentField = "",
  monetaryField = "",
  id = "",
  disabledInputs = false,
  transactionAmount,
  summed = 0,
}) => {
  const [percent, setPercent] = useState(
    MaskService.toMask("decimal", parseFloat(percentValue).toFixed(2) || "0.00")
  );
  const [monetary, setMonetary] = useState(
    MaskService.toMask(
      "decimal",
      parseFloat(monetaryValue).toFixed(2) || "0.00"
    )
  );

  const summedFees = array.reduce((acc, current) => {
    return acc + parseFloat(current.fees || 0.0);
  }, 0);

  const summedFines = array.reduce((acc, current) => {
    return acc + parseFloat(current.fine || 0.0);
  }, 0);

  const handleSetValuePercent = (e, percentField) => {
    e.target.value = MaskService.toMask("decimal", e.target.value || "0.00", 2);

    let formatedString = MaskService.removeMaskDecimal(
      e.target.value
    ).toString();

    let formatedFloat = parseFloat(formatedString);

    const rowValue = parseFloat(row.value || row.valor || row.valordocto);
    const computedValue = parseFloat(row[percentField] || 0.0);

    const maxValue = transactionAmount - (summed + summedFees + summedFines);

    const maxValuePercent = parseFloat((maxValue / rowValue) * 100).toFixed(2);

    if (formatedFloat > parseFloat(maxValuePercent) + computedValue) {
      formatedFloat = parseFloat(
        parseFloat(maxValuePercent) + computedValue
      ).toFixed(2);
    }

    const arrayCopy = JSON.parse(JSON.stringify(array));

    const calcMonetary = parseFloat((rowValue * formatedFloat) / 100).toFixed(
      2
    );

    const updatedRows = arrayCopy.map((obj) => {
      if (obj.typeBillID === row.typeBillID) {
        obj[percentField] = parseFloat(formatedFloat).toFixed(2);
        obj[monetaryField] = calcMonetary;
      }
      return obj;
    });

    setNewArray(updatedRows);

    setPercent(
      MaskService.toMask("decimal", parseFloat(formatedFloat).toFixed(2), 2)
    );

    setMonetary(MaskService.toMask("decimal", calcMonetary, 2));
  };

  const handleSetValueMonetary = (e, monetaryField) => {
    e.target.value = MaskService.toMask("decimal", e.target.value || "0.00", 2);

    let formatedString = MaskService.removeMaskDecimal(
      e.target.value
    ).toString();

    let formatedFloat = parseFloat(formatedString);

    const maxValue = transactionAmount - (summed + summedFees + summedFines);
    let stringMaxValue = parseFloat(maxValue).toFixed(2);

    const computedValue = parseFloat(row[monetaryField] || 0.0);

    if (formatedFloat > parseFloat(stringMaxValue) + computedValue) {
      formatedFloat = parseFloat(
        parseFloat(stringMaxValue) + computedValue
      ).toFixed(2);
    }

    const arrayCopy = JSON.parse(JSON.stringify(array));

    const rowValue = row.value || row.valor || row.valordocto;

    const calcPercent = parseFloat((formatedFloat / rowValue) * 100).toFixed(2);

    const updatedRows = arrayCopy.map((obj) => {
      if (obj.typeBillID === row.typeBillID) {
        obj[percentField] = calcPercent;
        obj[monetaryField] = parseFloat(formatedFloat).toFixed(2);
      }

      return obj;
    });

    setNewArray(updatedRows);

    setMonetary(
      MaskService.toMask("decimal", parseFloat(formatedFloat).toFixed(2), 2)
    );
    setPercent(MaskService.toMask("decimal", calcPercent, 2));
  };

  useEffect(() => {
    setPercent(
      MaskService.toMask(
        "decimal",
        parseFloat(percentValue).toFixed(2) || "0.00"
      )
    );
  }, [percentValue]);

  useEffect(() => {
    setMonetary(
      MaskService.toMask(
        "decimal",
        parseFloat(monetaryValue).toFixed(2) || "0.00"
      )
    );
  }, [monetaryValue]);

  return (
    <div style={{ display: "flex", width: "200px" }} id={id}>
      <div
        style={{
          width: "130px",
          marginRight: "10px",
        }}
      >
        <TextField
          style={{ background: "#00000017" }}
          value={percent}
          id={`${id}_percent`}
          onChange={(e) => {
            handleSetValuePercent(e, percentField);
          }}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
            style: { fontSize: "0.875rem", fontFamily: "Roboto" },
          }}
          disabled={disabledInputs}
        />
      </div>
      <div style={{ width: "130px" }}>
        <TextField
          value={monetary}
          id={`${id}_monetary`}
          onChange={(e) => {
            handleSetValueMonetary(e, monetaryField);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">R$</InputAdornment>
            ),
            style: { fontSize: "0.875rem", fontFamily: "Roboto" },
          }}
          disabled={disabledInputs}
        />
      </div>
    </div>
  );
};

export default memo(DoubleInputs);
